import { makeSelector } from "../../../testing/index.js";
const TestingAttrs = {
  backButton: "data-back-button",
  links: "data-link"
};
const BreadcrumbsSelectors = {
  backButton: makeSelector("Back button", TestingAttrs.backButton),
  links: makeSelector("Links", TestingAttrs.links)
};
export {
  BreadcrumbsSelectors,
  TestingAttrs
};
